export const TILE = 64;
export const MAP_COLS = 15;
export const MAP_ROWS = 13;
export const MAP_W = MAP_COLS * TILE;
export const MAP_H = MAP_ROWS * TILE;

export const HUD_HEIGHT = 64;
export const GAME_W = MAP_W;
export const GAME_H = MAP_H + HUD_HEIGHT;

export const PLAYER_SPEED_BASE = 192;
export const SPEED_POWERUP_INCREMENT = 1;
export const PLAYER_SPEED_MAX_MULT = 3;
export const BOMB_FUSE_MS = 2500;
export const BOMB_EXPLODE_MS = 600;
export const PLAYER_START_LIVES = 3;
export const PLAYER_START_BOMBS = 1;
export const PLAYER_START_RADIUS = 2;
export const INVULNERABLE_MS = 2500;

export const RESPAWN_DELAY_MS = 1200;
export const LEVEL_COMPLETE_DELAY_MS = 1500;

export const SCORE_BLOCK = 10;
export const SCORE_POWERUP = 50;
export const SCORE_ENEMY_BASIC = 100;
export const SCORE_ENEMY_FAST = 200;
export const SCORE_ENEMY_SMART = 300;
export const SCORE_ENEMY_HUNTER = 250;
export const SCORE_ENEMY_BOMBER = 350;
export const SCORE_ENEMY_BOSS = 1000;
export const SCORE_TIME_BONUS = 10;

export const SAFE_ZONE_RADIUS = 2;

export const MAX_LEVELS = 30;
export const LEVELS_PER_WORLD = 6;
export const NUM_WORLDS = 5;

export const WORLD_NAMES = [
  'Classic Arena',
  'Frozen Fortress',
  'Lava Factory',
  'Cyber City',
  'Galactic Station',
];

export const WORLD_COLORS = [
  { floor: 0x7aafc8, wall: 0x4d7090, block: 0x8B5E14, bg: 0x2a5570 }, // Classic Arena — winter ice
  { floor: 0x1a4a6e, wall: 0x2a5070, block: 0x336688, bg: 0x0d2a40 }, // Frozen Fortress — deep ice
  { floor: 0x5a1a00, wall: 0x663300, block: 0xaa5500, bg: 0x330f00 }, // Lava Factory
  { floor: 0x0d1a2e, wall: 0x223344, block: 0x334466, bg: 0x060d18 }, // Cyber City
  { floor: 0x0a0a2a, wall: 0x222244, block: 0x334488, bg: 0x050510 }, // Galactic Station
];

export const POWERUP_COLORS: Record<string, number> = {
  extra_bomb: 0xff4444,
  fire_up: 0xff8800,
  speed_up: 0x44ff44,
  bomb_kick: 0x4488ff,
  remote_bomb: 0xff44ff,
  shield: 0xffff44,
  extra_life: 0xff66aa,
  fire_immunity: 0xff6600,
  wall_pass: 0x88ffff,
  bomb_pass: 0xffaa44,
};

export const POWERUP_LABELS: Record<string, string> = {
  extra_bomb: '+B',
  fire_up: '+F',
  speed_up: '+S',
  bomb_kick: 'K',
  remote_bomb: 'R',
  shield: 'SH',
  extra_life: '+L',
  fire_immunity: 'FI',
  wall_pass: 'WP',
  bomb_pass: 'BP',
};

export const ENEMY_COLORS: Record<string, number> = {
  basic: 0xee4444,
  fast: 0xff8800,
  hunter: 0xcc0088,
  smart: 0x0088cc,
  bomber: 0x884400,
  boss: 0x660088,
};

export const PLAYER_COLORS = [0x3399ff, 0xff4444, 0x44ff44, 0xffaa00];

export const SAVE_KEY = 'blast_arena_2026_v1';
